import type { ConsultationCallStep } from './Consultation'

/**
 * How much of the call progress bar each call step fills, in percent.
 */
export const consultationCallProgress: Record<
  ConsultationCallStep,
  { completed: number; pending: number }
> = {
  Unknown: { completed: 0, pending: 0 },
  Pending: { completed: 0, pending: 33 },
  InProgress: { completed: 33, pending: 33 },
  Done: { completed: 67, pending: 33 },
  Completed: { completed: 100, pending: 0 },
}
